import { Injectable, OnDestroy } from '@angular/core'
import {
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
  SemanticPathService,
  Translatable,
  WindowRef
} from '@spartacus/core'
import { Router } from '@angular/router'
import { mbCheckoutConfig } from '../config/mb-default-checkout-config'
import { mbCheckoutRoutingConfig } from '../config/mb-checkout-routing-config'
import { MbCheckoutStep } from '../models'
import { BehaviorSubject, Subscription } from 'rxjs'
import { MbConstants } from '../../shared/mb-constants'
import { MbCheckoutTypes } from '../../models'
import { ActiveCartService } from '@spartacus/cart/base/core'
import { Order } from '@spartacus/order/root'

@Injectable({
  providedIn: 'root'
})
export class MbCheckoutNavigationService implements OnDestroy {

  showPaymentProviderPage = new BehaviorSubject<boolean>(false)
  constants = MbConstants

  private nextCheckoutRoute: string | undefined
  private checkoutType: MbCheckoutTypes | undefined
  private checkoutPageId: string | undefined
  private checkoutSteps = mbCheckoutConfig
  private checkoutRoutes = mbCheckoutRoutingConfig
  private mbCheckoutTypes = MbCheckoutTypes
  private subscription: Subscription = new Subscription()
  private navigateToNextCheckoutStepAfterCartReloads: boolean = false

  constructor (protected activeCartService: ActiveCartService,
               protected router: Router,
               protected semanticPathService: SemanticPathService,
               protected globalMessageService: GlobalMessageService,
               protected winRef: WindowRef,
               protected routingService: RoutingService) {
    // TODO refactor here
    this.subscription.add(this.activeCartService.getActive().subscribe(cart => {
      this.nextCheckoutRoute = this.getNextCheckoutRoute(cart?.checkoutStatus?.checkoutPageId)
      this.checkoutPageId = cart?.checkoutStatus?.checkoutPageId
      this.checkoutType = cart?.checkoutStatus?.checkoutType
      if (this.navigateToNextCheckoutStepAfterCartReloads && this.nextCheckoutRoute) {
        this.navigateToNextCheckoutStepAfterCartReloads = false
        this.navigateToNextCheckoutStep()
      }
    }))
  }

  ngOnDestroy (): void {
    this.subscription.unsubscribe()
  }

  setPaymentProviderPageVisibility (isVisible: boolean) {
    this.showPaymentProviderPage.next(isVisible)
  }

  navigateToNextCheckoutStep (forceReloadCart: boolean = false) {
    if (this.nextCheckoutRoute) {
      this.winRef.localStorage?.removeItem(this.constants.CART_MIGRATION_SPARTACUS_KEY + this.constants.REDIRECT_URL_COOKIE)
      this.router.navigate([this.nextCheckoutRoute])
        .catch((error: Error) => console.error(error))
    } else if (this.checkoutPageId === this.constants.CHECKOUT_STEP_LOGIN) {
      if (!forceReloadCart) {
        this.winRef.localStorage?.setItem(this.constants.CART_MIGRATION_SPARTACUS_KEY + this.constants.REDIRECT_URL_COOKIE, 'true')
        this.router.navigate([this.semanticPathService.get('checkoutContactDetails')])
          .catch((error: Error) => console.error(error))
      } else {
        this.navigateToNextCheckoutStepAfterCartReloads = true
        this.winRef.localStorage?.removeItem(this.constants.CART_MIGRATION_SPARTACUS_KEY + this.constants.REDIRECT_URL_COOKIE)
      }
    } else {
      this.winRef.localStorage?.removeItem(this.constants.CART_MIGRATION_SPARTACUS_KEY + this.constants.REDIRECT_URL_COOKIE)
      this.router.navigate([this.constants.CART_PAGE_URL])
        .catch((error: Error) => console.error(error))
    }
  }

  navigateToCartPage (globalErrorToDisplay?: string | Translatable) {
    this.router.navigateByUrl(this.constants.CART_PAGE_URL).then(() => {
      if (globalErrorToDisplay) {
        this.globalMessageService.add(globalErrorToDisplay, GlobalMessageType.MSG_TYPE_ERROR, 17000)
      }
    }).catch((error: Error) => console.error(error))
  }

  navigateToReviewPage (globalErrorToDisplay?: string | Translatable) {
    this.router.navigate([this.semanticPathService.get('checkoutReview')]).then(() => {
      if (globalErrorToDisplay) {
        this.globalMessageService.add(globalErrorToDisplay, GlobalMessageType.MSG_TYPE_ERROR, 6000)
      }
    }).catch((error: Error) => console.error(error))
  }

  navigateToPaymentProviderPage () {
    this.router.navigate([this.semanticPathService.get('checkoutPaymentProviderPage')]).catch((error: Error) => console.error(error))
  }

  navigateToConfirmationPage (order: Order | undefined): Promise<boolean | void> {
    return this.routingService.go({ cxRoute: 'checkoutConfirmation', params: order }).catch((error: Error) => console.error(error))
  }

  navigateBackFromQuoteInfo () {
    this.router.navigateByUrl(this.constants.CART_PAGE_URL).catch((error: Error) => console.error(error))
  }

  navigateBackFromContactDetails () {
    if (this.checkoutType === this.mbCheckoutTypes.CHECKOUT_TYPE_A
    || this.checkoutType === this.mbCheckoutTypes.CHECKOUT_TYPE_B
    || this.checkoutType === this.mbCheckoutTypes.CHECKOUT_TYPE_C) {
      this.router.navigate([this.semanticPathService.get('checkoutQuoteInfo')]).catch((error: Error) => console.error(error))
    } else {
      //TODO: change when login is implemented
      this.router.navigateByUrl(this.constants.CART_PAGE_URL).catch((error: Error) => console.error(error))
    }
  }

  private getNextCheckoutRoute (stepID?: string) {
    const routeID: string | undefined = this.getRouteID(stepID)

    if (routeID) {
      return this.checkoutRoutes?.routing?.routes?.[routeID]?.paths?.[0]
    }
    return
  }

  private getRouteID (stepID?: string) {
    return this.checkoutSteps?.checkout?.steps?.find((step: MbCheckoutStep) => step?.id === stepID)?.routeName
  }
}
